import { useRef, memo } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { TripLocation } from './Location';

const style = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
    width: '100%'
}
export const LocationCard = ({ location, index, count, last, onChange, onRemove, moveCard, findCard }) => {
    const ref = useRef(null)
    const [{ handlerId }, drop] = useDrop({
        accept: 'locationcard',
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            console.log('hover 1');
            if (!ref.current) {
                return
            }
            console.log('hover 2');
            const dragIndex = item.index
            const hoverIndex = index
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            console.log('hover 3');
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }
            // Time to actually perform the action
            moveCard(dragIndex, hoverIndex)
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: 'locationcard',
        item: () => {
            let id = location.sequence;
            return { id, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })
    const opacity = isDragging ? 0 : 1
    drag(drop(ref))

    const setLocation = (l) => {
        onChange(l);
    }

    const moveOnePosition = (isUp) => {
        if (isUp) {
            if (index > 0) {
                moveCard(index, index - 1);
            }
        }
        else {
            if (!last) {
                moveCard(index, index + 1);
            }
        }
    }

    let del = <i className="pi pi-times-circle mr-1 text-red-600 cursor-pointer text-xl pl-2" onClick={() => onRemove()}></i>;
    if (index == 0 || index == 1 || last) {
        del = <></>;
    }

    let moveUp = <i className="p-2 pi pi-arrow-up text-black cursor-pointer text-large" tooltip="Move Up" onClick={() => moveOnePosition(true)}></i>;
    let moveDown = <i className="p-2 pi pi-arrow-down text-black cursor-pointer text-large" tooltip="Move Down" onClick={() => moveOnePosition(false)}></i>;

    if (index == 0 || !location || !location.place_id) {
        moveUp = <></>;
        moveDown = <></>;
    }

    if (last || index == (count - 2)) {
        moveDown = <></>;
    }

    return (
        <div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
            <div className="text-right">{moveUp}{moveDown}{del}</div>
            <TripLocation value={location} onChange={(loc) => setLocation(loc)} readonly={false}></TripLocation>
        </div>
    )
}
